import moment from 'moment';

export const DOW_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function fmtHours(mins) {
    const h = Math.floor(mins / 60), m = mins % 60;
    return m ? `${h}h ${m}m` : `${h}h`;
}

// "Aug 25 – Jun 15" from recurring MM-DD bounds; null when year-round
export function fmtContractYear(yearStart, yearEnd) {
    if (!yearStart || !yearEnd) return null;
    const fmt = mmdd => moment(mmdd, 'MM-DD').format('MMM D');
    return `${fmt(yearStart)} – ${fmt(yearEnd)}`;
}

// "Mon – Fri, 9:00am – 5:00pm; Sat, 10:00am – 2:00pm"
export function summarizeSchedule(blocks) {
    if (!blocks || !blocks.length) return 'No contracted hours declared';
    const byDow = {};
    for (const b of blocks) (byDow[b.dow] = byDow[b.dow] || []).push(`${b.start}-${b.end}`);
    const sig = dow => (byDow[dow] || []).sort().join(',');
    const parts = [];
    let runStart = null;
    for (let dow = 0; dow <= 7; dow++) {
        const has = dow <= 6 && sig(dow);
        if (has && runStart !== null && sig(dow) === sig(runStart)) continue;
        if (runStart !== null && sig(runStart)) {
            const endDow = dow - 1;
            const label = runStart === endDow
                ? DOW_NAMES[runStart].slice(0, 3)
                : `${DOW_NAMES[runStart].slice(0, 3)} – ${DOW_NAMES[endDow].slice(0, 3)}`;
            const times = (byDow[runStart] || []).map(t => {
                const [s, e] = t.split('-');
                return `${moment(s, 'HH:mm').format('h:mma')} – ${moment(e, 'HH:mm').format('h:mma')}`;
            }).join(', ');
            parts.push(`${label}, ${times}`);
        }
        runStart = has ? dow : null;
    }
    return parts.join('; ');
}
